import { motion } from "framer-motion";

const SIZES = { sm: "h-12", md: "h-14", lg: "h-20" };

export default function Logo({ size = "sm", className = "", testId = "brand-logo", stacked = false }) {
  return (
    <motion.img
      src={stacked ? "/logo-stacked.png" : "/logo-horizontal.png"}
      alt="ONWARD MEDIA"
      data-testid={testId}
      className={`${stacked ? "h-auto w-44" : `${SIZES[size]} w-auto`} select-none ${className}`}
      whileHover={{ scale: 1.04 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      draggable={false}
    />
  );
}
